module.exports = function (Component) { Component.options.__i18n = '{"en":{"button_settings_title":"Settings"},"de":{"button_settings_title":"Settings"}}' }


//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/MyStream.vue
// module id = 145
// module chunks = 1